import { useQuery } from '@tanstack/react-query';
import { getFaqs } from '@nomiss/services';

export const faqsQueryKeys = {
  list: (lang?: string, category?: string) =>
    ['account', 'faqs', lang ?? '', category ?? ''] as const,
};

export function useFaqs(lang?: string, category?: string, enabled = true) {
  return useQuery({
    queryKey: faqsQueryKeys.list(lang, category),
    queryFn: () => getFaqs(lang, category),
    enabled,
  });
}
